import "./RequestComment.css";
import TimelineItem from "./TimelineItem";

export default function RequestComment({ comments, onDeleteComment }) {

  const formatDate = (date) =>
    `${date.getDate()} ${date.toLocaleString("default", {
      month: "long",
    })}, ${date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })}`;


  const Timeline = ({ comments }) => {
    return (
      <div className="timeline">
        {comments.map((comment, index) => {
          const avatarInitial = comment?.user_name?.[0]?.toUpperCase() || "";

          const hasBothRoles = comments.some((c) => c.user_id === comment.user_id && c.user_role === "dsp") && 
            comments.some((c) => c.user_id === comment.user_id && c.user_role === "drone_pilot");

          const avatarColor = hasBothRoles ? "#0F5EFF" : comment?.user_role === "dsp" ? "#0F5EFF" : "#6b7280";

          return (
            <TimelineItem
              commentId={comment?.id}
              userId={comment?.user_id}
              avatar={avatarInitial}
              avatarColor={avatarColor}
              formattedTime={formatDate(new Date(comment?.time))}
              name={comment?.user_name}
              timestamp={comment?.time}
              message={comment?.content}
              handleDeleteComment={(id) => {
                console.log("id inside requestComment ", id);
                onDeleteComment(id)

              }}
              isLast={index === comments?.length - 1}
            />
          )
        })}
      </div>
    );
  };
  return (
    <main className="timeline-container">
      <Timeline comments={comments} />
    </main>
  );
}
